import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { getStockChangedText } from '../../../utils/administrationUtils'

type GenericOutcomeContentProps = {
  record: any
  outcome?: any
}

const GenericOutcomeContent = ({
  record,
  outcome
}: GenericOutcomeContentProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  const adminData = outcome?.administration
  const dateStatus = outcome?.dateStatus
  const unit =
    dateStatus?.doseUnit ||
    adminData?.medication?.doseUnit ||
    record?.medication?.stockUnit ||
    adminData?.quantityType ||
    ''

  const stockChangedText = getStockChangedText({
    administration: adminData,
    dateStatus: adminData ? dateStatus : undefined,
    unit,
    stockChanged: dateStatus?.stockChanged ?? outcome?.stockChanged,
    t
  })

  const comment = adminData?.notes || '-'

  return (
    <>
      <InfoRow>
        <Label level={2}>{t('HAS_STOCK_AMOUNT_CHANGED')}</Label>
        <Value>{stockChangedText}</Value>
      </InfoRow>
      <InfoRow>
        <Label level={2}>{t('COMMENT')}</Label>
        <Value>{comment || '-'}</Value>
      </InfoRow>
    </>
  )
}

const Label = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
  font-weight: 500;
`

const Value = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  font-weight: 400;
`

const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export default GenericOutcomeContent
